// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
   appearance: none;
   margin: 0;
}

.block-form{
   position: absolute;
   margin-left: 15px;
}
`, "",{"version":3,"sources":["webpack://./src/app/e-signature/sign-off/view-document/view-document.component.css"],"names":[],"mappings":"AAAA;;GAIG,gBAAgB;GAChB,SAAS;AACZ;;AAEA;GACG,kBAAkB;GAClB,iBAAiB;AACpB","sourcesContent":["input[type=number]::-webkit-inner-spin-button,\ninput[type=number]::-webkit-outer-spin-button {\n   -webkit-appearance: none;\n   -moz-appearance: none;\n   appearance: none;\n   margin: 0;\n}\n\n.block-form{\n   position: absolute;\n   margin-left: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
